import { Feature } from './featureflag/featureFlags';
import { getFeatureFlag } from './featureflag/getFeatureFlags';

/**
 * Send tag log to Dynatrace.
 *
 * @param data - Tag log to Dynatrace.
 *
 */
export const sendTagLog = (data: any): void => {
    if (getFeatureFlag(Feature.Dynatrace) && window.dynatrace)
        window.dynatrace.sendBizEvent('TAG - ACHS Virtual', data);
};
